import WordAlertCard from "./WordAlertCard";
import EmotionPatternCard from "./EmotionPatternCard";
import { NoAlertsOverlay } from "./NoAlertsOverlay";
import { joinWithAnd } from "@/utils/helperFunctions";
import {
  getOtherWellnessActionText,
  isOtherWellnessAction,
} from "@/utils/wellnessActions";

const Alerts = ({ state, updateState, name, filteredAlerts, user }) => {
  const toSentenceCase = (value) =>
    value ? value.charAt(0).toUpperCase() + value.slice(1).toLowerCase() : "";

  var betterTimeLabels = {
    "10 minutes": "in the last 10 minutes",
    "1 hour": "in the last 1 hour",
    "2 hours": "in the last 2 hours",
    "24 hours": "in the last 24 hours",
    week: "last week",
    month: " last month",
    "3 months": "in the last 3 months",
    "6 months": "in the last 6 months",
    year: "last year",
    "2 years": "in the last 2 years",
  };

  return (
    <div className="p-3 sm:p-0 lg:p-6 lg:border lg:border-[#DDDDDD] bg-white rounded relative lg:max-h-[64vh] 2xl:max-h-[70vh] lg:overflow-y-auto">
      {/* Header */}
      <div className="flex justify-between items-center mb-2 sm:mb-3">
        <h2 className="text-[22px] sm:text-[24px] font-bold">
          {name && state.chosenStudent && state.chosenStudent !== "All Students" ? `${name}'s Alerts Timeline` : "Alerts Timeline"}
        </h2>
      </div>
      <div className="flex flex-col relative">
        {filteredAlerts &&
          [...filteredAlerts].map((alert, index) => {
            const isFirst = index === 0;
            const isLast = index === filteredAlerts.length - 1;

            // Format date for display
            const alertDate = new Date(alert.createdAt);
            const dateString = alertDate.toLocaleDateString("en-US", {
              month: "long",
              day: "numeric",
            });

            // Format timestamp
            const timestamp = alertDate.toLocaleString("en-US", {
              month: "short",
              day: "numeric",
              year: "numeric",
              hour: "numeric",
              minute: "2-digit",
              hour12: true,
            });

            const value = alert.type.value || "";
            const emotions =
              typeof value === "string"
                ? value.split(",").map((e) => e.trim())
                : [];
            const totalCounts = state.counts.reduce(
              (sum, count) => sum + count.current,
              0
            );
            const matchingEmotionTotal = state.counts.reduce((sum, count) => {
              return emotions.includes(count.name) ? sum + count.current : sum;
            }, 0);
            const emotionPercentage =
              totalCounts > 0
                ? Math.round((matchingEmotionTotal / totalCounts) * 100)
                : 0;

            const rawAction = alert?.wellness?.action || "";
            const content = isOtherWellnessAction(rawAction)
              ? toSentenceCase(getOtherWellnessActionText(rawAction) || rawAction)
              : toSentenceCase(rawAction);

            // Define correct choice of time label
            const timeLabel = betterTimeLabels[state.chosenTime];

            if (alert.type.kind === "word") {
              return (
                <WordAlertCard
                  key={`${alert._id}-${alert.read}`}
                  date={dateString}
                  title={`${name} used the word${
                    Array.isArray(alert.type.value) &&
                    alert.type.value.length > 1
                      ? "s"
                      : ""
                  } "${joinWithAnd(
                    Array.isArray(alert.type.value)
                      ? alert.type.value
                      : [alert.type.value]
                  )}"`}
                  timestamp={timestamp}
                  content={content}
                  used_word={alert.type.value}
                  isFirst={isFirst}
                  isLast={isLast}
                  state={state}
                  name={name}
                  currentAlert={alert}
                  user={user}
                  updateState={updateState}
                />
              );
            } else if (alert.type.kind === "emotion") {
              return (
                <EmotionPatternCard
                  key={`${alert._id}-${alert.read}`}
                  date={dateString}
                  value={alert.type.value}
                  timestamp={timestamp}
                  isFirst={isFirst}
                  isLast={isLast}
                  alert={alert}
                  name={name}
                  studentEmotionData={state.studentEmotionData}
                  studentEmailToNameMap={state.studentEmailToNameMap}
                  emotionPercentage={emotionPercentage}
                  timeLabel={timeLabel}
                  filteredDataPoints={state.filteredDataPoints}
                  state={state}
                  user={user}
                  updateState={updateState}
                />
              );
            }

            return null; // Skip unknown alert types
          })}

        {/* No Alerts Overlay */}
        {(!filteredAlerts || filteredAlerts.length === 0) && (
          <NoAlertsOverlay />
        )}
      </div>
    </div>
  );
};

export default Alerts;
